import { getAuthToken } from '@/utils/local-storage'
import HttpRequest from './http_request'

export default class BrandProvider extends HttpRequest {
  getBrandWarehouse () {
    this.setHeader(getAuthToken())
    return this.get('/brands/warehouse')
  }
}
